function configs(labels, datasets) {
  return {
    data: {
      labels,
      datasets: datasets.map((item) => ({
        label: item.label,
        backgroundColor: item.backgroundColor,
        data: item.data,
        borderRadius: 4,
        maxBarThickness: 28,
      })),
    },

    options: {
      indexAxis: "y",

      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          display: false,
        },
      },

      scales: {
        x: {
          beginAtZero: true,

          ticks: {
            color: "#000",
            callback: (value) => `${value} hrs`,
          },

          grid: {
            color: "#e0e0e0",
          },
        },

        y: {
          ticks: {
            color: "#000",
            font: {
              size: 12,
            },
          },

          grid: {
            display: false,
          },
        },
      },
    },
  };
}

export default configs;